import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/actual/array/group-by';
import { unregister as unregisterServiceWorker } from './serviceWorker'

unregisterServiceWorker();

require('./app');
